module.exports = __webpack_public_path__ + "static/media/ThePunisher.6a1411ad.png";